import Header from "../components/Header"
import Footer from "../components/Footer"
import { ArrowRight } from "lucide-react"
import { StickyNavigation } from "../components/common/StickyNavgation"
import { AccessRect } from '../components/common/AccessRect'
import hongkongPricevolume from '../assets/images/hongkong-pricevolume.png'
import { Link, useLocation } from "react-router-dom"
import { useEffect, useRef } from 'react'
import { TrialFormPage } from '@/components/common/Trial/TrialFormPage';

export default function HongKongSARPage() {
  const products = [
    {
      title: 'Price-Volume Factors',
      picUrl: hongkongPricevolume,
      contents: [
        '1. The underlying data leverage market data (OHLCV).',
        '2. Factor Mining Method: expert-driven manual research.',
        '3. Easy to integrate: SFTP/API; data is delivered in machine-readable standardized formats.'
      ]
    },
    {
      title: 'Coming soon',
      picUrl: '',
      contents: []
    },
    {
      title: '',
      picUrl: '',
      contents: []
    },
    {
      title: '',
      picUrl: '',
      contents: []
    },
  ]

  const navigationItems = products.map((product, index) => {
    return (
      {
        id: index + 1,
        title: product.title,
        content: (
          <div className="container container-max-w mx-auto space-y-20">
            {
              index % 2 === 0 ? (
              <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 pb-[68px] mt-[63px] ${index !== products.length - 1 && 'border-b border-[#EFEFEF]'}`}>
                <div>
                  <img
                    src={product.picUrl}
                    alt="Price-Volume Factors"
                    className="h-[248px]"
                  />
                </div>
                <div>
                  <h2 className="text-4xl font-bold mb-[24px]">{product.title}</h2>
                  <ol className="space-y-1 text-[16px] mb-[48px] text-[#4D4D4D]">
                    {
                      product.contents.map(content => {
                        return (<li>{ content }</li>)
                      })
                    }
                  </ol>
                  <div className="text-[#0066FF] hover:text-[#297FFF] text-[20px] cursor-pointer">
                    <Link to="/data-product" className="font-bold group flex items-center">Learn More
                      <ArrowRight className="w-[24px] h-[24px] transition-transform duration-300 group-hover:translate-x-2 group-hover:text-[#297FFF] ml-[24px]" />
                    </Link>
                  </div>
                </div>
              </div>
              ) : (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 pb-[68px] border-b border-[#EFEFEF] mt-[63px]">
                  <div>
                    <h2 className="text-4xl font-bold mb-[24px]">{product.title}</h2>
                    <ol className="space-y-1 text-[16px] mb-[48px] text-[#4D4D4D]">
                      {
                        product.contents.map(content => {
                          return (<li>{ content }</li>)
                        })
                      }
                    </ol>
                    <div className="text-[#0066FF] hover:text-[#297FFF] text-[20px] cursor-pointer">
                      <Link to="/data-product" className="font-bold group flex items-center">Learn More
                        <ArrowRight className="w-[24px] h-[24px] transition-transform duration-300 group-hover:translate-x-2 group-hover:text-[#297FFF] ml-[24px]" />
                      </Link>
                    </div>
                  </div>
                  <div>
                    <img
                      src={product.picUrl}
                      alt="Price-Volume Factors"
                      className="h-[248px]"
                    />
                  </div>
                </div>
              )
            }
          </div>
        )
      }
      
    )
  })

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');
  const product = searchParams.get('product');

  const childRef = useRef();
  
    useEffect(() => {
      if (childRef.current && id && product) {
        childRef.current.scrollToSection(id, product)
      }
    }, []);
  return (
    <div className="min-h-screen">
      <Header scrollThreshold={715} />
      {/* Hero Section */}
      <section className="relative min-h-[70vh] flex items-center justify-center text-white font-titillium">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url('../assets/images/hongkong-banner.png')]">
        </div>

        <div className="relative z-10 container container-max-w mx-auto">
          <div className="max-w-[865px]">
            <h1 className="text-[48px] font-bold mb-[12px] text-white">
              Your Quantitatively Engineered Bridge to Hong Kong's Alpha
            </h1>
            <div className="text-lg">
              <p>
                <strong>Coverage:</strong> More than 2600 Stocks.
              </p>
              <p>
                <strong>Number of factors:</strong> Offering 36 Alpha factors, It is tailored to enhance your portfolio construction and multi-factor strategies.
              </p>
            </div>
          </div>
        </div>
      </section>
      <StickyNavigation items={navigationItems} heroHeight={500} navHeight={60} ref={childRef}></StickyNavigation>
      <AccessRect></AccessRect>
      <TrialFormPage></TrialFormPage>
      <Footer />
    </div>
  )
}
